import React, { useEffect, useState, useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import Sidebar from "../comman/Sidebar";
import CustomerFilterModel from "../model/CustomerFilterModel";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Checkbox,
  Grid,
  InputAdornment,
  ListItemText,
  Stack,
  TableSortLabel,
  Button,
  PaginationItem,
  Icon,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Paper from "@mui/material/Paper";
import {
  CUSTOMER_LIST_URL,
  GET_ALL_CUSTOMERS_URL,
  GET_ALL_CUSTOMER_FILTER_URL,
} from "../../constants/ApiRoute";
import { authHeader } from "../comman/MainFunction";
import API from "../comman/API";

import Pagination from "@mui/material/Pagination";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { Link, useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { CUSTOMER_HISTORY, ADD_CUSTOMER } from "../../constants/RoutePath";
import UserClearFilter from "../model/UserClearFilter";
import CustomPageLoading from "../comman/CustomPageLoading";
import Navbar from "../comman/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomersList } from "../../redux/action";
import { useToast } from "../comman/CustomMessages";
import moment from "moment";
import ExpandLessSharpIcon from "@mui/icons-material/ExpandLessSharp";
import ExpandMoreSharpIcon from "@mui/icons-material/ExpandMoreSharp";
import UnfoldMoreSharpIcon from "@mui/icons-material/UnfoldMoreSharp";
import sortupdownarrowIcon from "../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../images/sort_down_arrow.svg";

//import Checkbox from '@mui/material/Checkbox';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { PAGE_OFFSET } from "../../redux/action/ActionType";
import NoRecordFound from "../comman/NoRecordFound";
import * as types from "../../redux/action/ActionType";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const filterInitial = {
  customerStatusActive: "",
  customerStatus: "",
  customer: [],
  billingDefaultDayRate: "",
  billingDefaultperiod: "",
  page: 0,
  order: '',
  orderBy: ''
};

const Customer = () => {
  const customerListSelectFilter = useSelector(
    (s) => s.CustomerListSelectFilter
  );
  console.log(
    customerListSelectFilter,
    "CustomerListSelectFilterCustomerListSelectFilter11111111111"
  );
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  console.log(list, "llisttttttttttt");
  const showToast = useToast();
  const [total, setTotal] = useState(0);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(0);
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [filter, setFilter] = React.useState(filterInitial);
  const [clearFlag, setClearFlag] = useState(false);
  const [clearFiltervalue, setClearFilterValue] = useState(false);
  const [search, setSearch] = React.useState([]);
  const [orderBy, setOrderBy] = useState("");
  const [applyFilterFlag, setApplyFilterFlag] = React.useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  console.log(selectedCustomers, "setFiltersetFiltersetFilter");
  console.log(filter, "filterfilterfilterfilterfilterfilterfilter");
  const [order, setOrder] = useState("");
  console.log(orderBy, "orderorderorderorderorderorderorderorderorder", order);
  const [backButtonFilter, setBackButtonFilter] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [sortClickedTime, setSortClickedTime] = useState("");
  const currentPage = useSelector((r) => r.PageReducer);
  console.log(currentPage, "currentPagecurrentPagecurrentPagecurrentPage");

  const dispatch = useDispatch();
  const location = useLocation();
  const customerListSel = deCryptFun(
    useSelector((s) => s.AllCustomerListReducer)
  );
  const customerList = customerListSel ? JSON.parse(customerListSel).data : [];

  const findDuplicateCustomerId = (array) => {
    let seen = new Set();
    let duplicates = new Set();

    array.forEach((obj) => {
      if (seen.has(obj.UserId)) {
        duplicates.add(obj.UserId);
      } else {
        seen.add(obj.UserId);
      }
    });

    return Array.from(duplicates);
  };

  const handleSearchOnChange = (event, newValue) => {
    if (event.target.type != "text") {
      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: {
          ...customerListSelectFilter,
          page: 0
        },
      });
      setFilter({...filter, page: 0})
      console.log(customerListSelectFilter.page, 'aijaijihshhbjkcbcjkhsa')
      const duplicateArray = findDuplicateCustomerId(newValue);
      if (duplicateArray && duplicateArray.length > 0) {
        const updatedNewArray = newValue.filter(
          (obj) => obj.UserId !== duplicateArray[0]
        );
        newValue = updatedNewArray;
      }

      const uniqueSelectedProjects = newValue.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.UserId === item.UserId)
      );
      setSelectedCustomers(uniqueSelectedProjects);
      const mappedValue = uniqueSelectedProjects.map((id)=> id.UserId)
       console.log(mappedValue,'uniqueSelectedProjectsuniqueSelectedProjects')
      if (mappedValue?.length == 0) {
        dispatch({
          type: types.CUSTOMER_SELECT_LIST_FILTER,
          payload: {
            ...filter,
            customer: [],
          },
        });
        setFilter({...filter, page: 0})
      }

      // handleSearchStateReset();

      // if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
      //   const idsString = uniqueSelectedProjects.map(item => item.UserId).join(',');
      //   getCustomerFilterList(idsString, 0);
      // } else {
      //   getCustomerFilterList("", 0);
      // }
    }

    // const uniqueSelectedProjects = newValue.filter(
    //   (item, index, self) =>
    //     index === self.findIndex((t) => t.UserId === item.UserId)
    // );
    // setSelectedCustomers(uniqueSelectedProjects);

    // handleSearchStateReset();

    // if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
    //   const idsString = uniqueSelectedProjects.map(item => item.UserId).join(',');
    //   getCustomerFilterList(idsString, 0);
    // } else {
    //   getCustomerFilterList("", 0);
    // }
    //  }
  };

  const handleSearchDeleteOnChange = (value) => {
    var arr = selectedCustomers.filter((item) => item.UserId !== value);
    var uniqueSelectedProjects = arr;
    setSelectedCustomers(arr);
    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: {
        ...filter,
        page: 0
      },
    });
    setFilter({
      ...filter,
      page: 0
    })
    setPage(0)
    console.log(arr.length, "arrrrrrrrrrrrrrrrrrr");
    if (arr?.length == 0) {
      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: {
          ...filter,
          customer: [],
        },
      });
    }
    // handleSearchStateReset();

    // if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
    //   const idsString = uniqueSelectedProjects.map(item => item.UserId).join(',');
    //   getCustomerFilterList(idsString, 0);
    // } else {
    //   getCustomerFilterList("", 0);
    // }
  };

  const handleSearchCheckboxOnChange = (value, isSelected) => {
    let uniqueSelectedProjects = "";
    if (isSelected) {
      var arr = selectedCustomers.filter(
        (item) => item.UserId !== value.UserId
      );
      uniqueSelectedProjects = arr;
      setSelectedCustomers(arr);
      console.log(customerListSelectFilter.page, '5555555555555555555')
      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: {
          ...filter,
          page: 0
        },
      });
      setFilter({...filter, page: 0})
    } else {
      const updatedProjects = [...selectedCustomers, value];
      setSelectedCustomers(updatedProjects);
      uniqueSelectedProjects = updatedProjects;
      const mappedValue = updatedProjects.map((id)=> id.UserId)
       console.log(mappedValue,'uniqueSelectedProjectsuniqueSelectedProjects')
      if (mappedValue?.length == 0) {
        dispatch({
          type: types.CUSTOMER_SELECT_LIST_FILTER,
          payload: {
            ...filter,
            customer: [],
            page: 0
          },
        });
        setFilter({...filter, page: 0})
      }else{
        console.log(customerListSelectFilter.page, '5555555555555555555')
        dispatch({
          type: types.CUSTOMER_SELECT_LIST_FILTER,
          payload: {
            ...filter,
            page: 0
          },
        });
        setFilter({...filter, page: 0})
      }
    }

    // handleSearchStateReset();

    // if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
    //   uniqueSelectedProjects.map(item => item.UserId);
    //   const idsString = uniqueSelectedProjects.map(item => item.UserId).join(',');
    //   getCustomerFilterList(idsString, 0);
    // } else {
    //   getCustomerFilterList("", 0);
    // }
  };

  const handleSearchStateReset = () => {
    setApplyFilterFlag(false);
    setPage(0);
    dispatch({
      type: PAGE_OFFSET,
      payload: 0,
    });
    setFilter((prevState) => ({
      ...prevState,
      customer: [],
      customerStatus: "",
      customerStatusActive: "",
      billingDefaultDayRate: "",
      billingDefaultperiod: "",
    }));
    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: {
        customer: [],
        customerStatus: "",
        billingDefaultDayRate: "",
        billingDefaultperiod: "",
        customerStatusActive: "",
        page: 0
      },
    });
  };
  useEffect(() => {
    const userIds = selectedCustomers.map((user) => user.UserId);

    if (userIds.length > 0) {
      const updatedFilter = { ...filter, customer: userIds };
      console.log(updatedFilter, "updatedfilter212345");
      setFilter(updatedFilter);
      setOrderBy(filter.orderBy)
      setOrder(filter.order)
      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: updatedFilter,
      });

      const idsString = userIds.join(",");
      getCustomerFilterList(idsString, 0);
    } else {
      console.log(customerListSelectFilter, "customerListSe87654lectFilter");
      setFilter(customerListSelectFilter);
      setOrderBy(customerListSelectFilter.orderBy)
      setOrder(customerListSelectFilter.order)
      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: customerListSelectFilter,
      });
      getCustomerFilterList("", 0);
    }
  }, [selectedCustomers, order]);

  const getCustomerFilterList = async (search, pageVal) => {
    const {
      customerStatus,
      customer,
      billingDefaultDayRate,
      billingDefaultperiod,
      customerStatusActive,
      order,
      orderBy,
      page
    } = customerListSelectFilter; // Use the current filter state
    console.log(
      "!customerStatus && customerStatus == 0",
      !customerStatus && customerStatus == 0
    );
    console.log(search, "customer customer12345", customer);
    console.log("!selectedCustomers && customerStatus == 0", selectedCustomers);
    console.log(
      page, pageVal,
      "ustomer/getCustomerFilterustomer/getCustomerFilter",
    );

    let data = {
      count: count,
      offset: pageVal,
    };
    if (order) {
      data.sort = order;
      data.orderBy = orderBy;
    }
    // if (typeof pageVal === "number") {
    //   data.offset = pageVal;
    // }
    if (customer && customer.length > 0) {
      data.userId = customer.join(",");
    }
    if (selectedCustomers && selectedCustomers.length > 0) {
      console.log("select value", selectedCustomers);
      const idsString = selectedCustomers.map((item) => item.UserId).join(",");

      data.userId = idsString;
    }
    if (customerStatus === 0) {
      console.log("select valuecustomerStatus", customerStatus);
      data.active = customerStatus;
    }

    if (customerStatusActive && customerStatusActive == 1) {
      data.active = customerStatusActive;
    }
    if (search) {
      data.userId = search;
    }
    if (billingDefaultperiod) {
      data.billingPeriod = billingDefaultperiod;
    }
    if (billingDefaultDayRate) {
      data.defaultDayRate = billingDefaultDayRate;
    }

    console.log("logged data", data);

    const config = {
      method: "GET",
      url: GET_ALL_CUSTOMER_FILTER_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
        flutterString: "",
      },
    };

    try {
      setLoading(true);
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        setList(parsedResponse.data);
        setTotal(Math.ceil(parsedResponse.totalCount / count));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  const getCustomerList = async () => {
    const { order, orderBy, page } = customerListSelectFilter;
     console.log(page,'pageeeee')
    let data = {
      count: count,
      offset: page,
    };
    if (order) {
      data.sort = order;
      data.orderBy = orderBy;
    }

    const config = {
      method: "GET",
      url: GET_ALL_CUSTOMER_FILTER_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
        flutterString: "",
      },
    };

    try {
      setLoading(true);
      const response = await API(config);
      let decryptedResponse = await deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        setList(parsedResponse.data);
        setTotal(Math.ceil(parsedResponse.totalCount / count));

        console.log("parsedResponse.data", parsedResponse.data);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  // const handleSortRequestOLD = (property) => {
  //   const isAsc = order === "asc";
  //   console.log(isAsc,'isAcccccccccccc')
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);
  //   dispatch({
  //     type: types.CUSTOMER_SELECT_LIST_FILTER,
  //     payload: {
  //       ...customerListSelectFilter,
  //       order: isAsc ? "desc" : "asc",
  //       orderBy: property
  //     }
  //   })
  // };

  const handleSortRequest = (property) => {
    const isAsc = orderBy === property && order === "asc";
    console.log(orderBy === property , 'orderByorderBy', order)
    if (orderBy === property && order === "desc") {
      setOrder("");
      setOrderBy("");
      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: {
          ...customerListSelectFilter,
          order: "", // Toggle between "asc" and "desc" or set to ""
          orderBy: "", // Set orderBy to property if it exists, otherwise set to ""
          page: 0,
        },
      });
      setFilter({...filter, 
        order: "", // Toggle between "asc" and "desc" or set to ""
        orderBy: "", // Set orderBy to property if it exists, otherwise set to ""
        page: 0,
      })
    }else{
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: {
          ...customerListSelectFilter,
          order: orderBy === property && order ? "desc" : "asc", // Toggle between "asc" and "desc" or set to ""
          orderBy: property ? property : "", // Set orderBy to property if it exists, otherwise set to ""
          page: 0,
        },
      });
      setFilter({...filter, 
        order: orderBy === property && order ? "desc" : "asc", // Toggle between "asc" and "desc" or set to ""
        orderBy: property ? property : "", // Set orderBy to property if it exists, otherwise set to ""
        page: 0,
      })
    }


    setPage(0);
    setSortClickedTime(new Date().toLocaleString());
  };

  const getSortIcon = (orderByValue) => {
    if (filter.orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  const sortedList = useMemo(() => {
    console.log(orderBy, "orderauuuuuuuuuuuuuuuuuuuu", order);
    if (orderBy) {
      return [...list].sort((a, b) => {
        if (orderBy === "CreatedDate") {
          const dateA = new Date(a[orderBy]).getTime();
          const dateB = new Date(b[orderBy]).getTime();

          return order === "asc" ? dateA - dateB : dateB - dateA;
        } else if (
          orderBy === "Active" ||
          orderBy === "BillingPeriod" ||
          orderBy === "DefaultDayRate"
        ) {
          const valueA = parseFloat(a[orderBy]);
          const valueB = parseFloat(b[orderBy]);
          console.log(valueA, valueB, "valueA - valueB");
          return order === "asc" ? valueA - valueB : valueB - valueA;
        } else {
          const valueA = a[orderBy].toLowerCase();
          const valueB = b[orderBy].toLowerCase();

          if (order === "asc") {
            return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
          } else {
            return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
          }
        }
      });
    }
    return list;
  }, [list, orderBy, order]);

  useEffect(() => {
    console.log("PAGE RENDRED.");
    getCustomerFilterList();
    dispatch(getAllCustomersList());
  }, []);

  const handleChangeCustomer = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(value);
    setApplyFilterFlag(false);
    setPage(0);

    setFilter((prevState) => ({
      ...prevState,
      customer: value,
      customerStatus: "",
      billingDefaultDayRate: "",
      billingDefaultperiod: "",
      customerStatusActive: "",
      page: 0
    }));

    if (value && value.length > 0) {
      getCustomerFilterList(value.join(","), "");
    } else {
      getCustomerFilterList("", "");
    }
  };

  useEffect(() => {
    console.log(clearFiltervalue, "cleartttttttttt");
    if (clearFiltervalue == true) {
      setPage(0);
      setFilter(filterInitial);
      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: {
          ...filter,
          page: 0
        },
      });
      setPersonName([]);
      getCustomerList();
    }

    if (customerListSelectFilter.customer?.length > 0) {
      const filteredCustomers = customerList.filter((item) =>
        customerListSelectFilter.customer.some((value) => item.UserId === value)
      );
      console.log(filteredCustomers, "fhhhhhhhhhhhhhhkssssssssssssss");
      setSelectedCustomers(filteredCustomers);
    }
  }, [clearFiltervalue]);

  const resetFilter = () => {
    setClearFlag(false);
  };

  const clearFilterOpen = () => {
    setPage(0);
    setFilter(filterInitial);
    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: filterInitial,
      page: 0
    });
    setPersonName([]);

    setSelectedCustomers([]);
    getCustomerList();
  };

  const filterOpenFun = () => {
    setOpenFilter(!openFilter);
  };

  const filterClose = () => {
    setOpenFilter(false);
    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: filter,
    });
    // if (applyFilterFlag == false) {
    //   setFilter(filterInitial);
    //   dispatch({
    //     type: types.CUSTOMER_SELECT_LIST_FILTER,
    //     payload: {
    //       ...filter
    //     },
    //   });
    // }
  };

  const applyFilterFun = (arr, localFilter) => {
    console.log(arr, "arrr1234567890");
    console.log(localFilter, "localFilterarrr1234567890");
    setOpenFilter(false);
    setApplyFilterFlag(true);

    const idsString = arr.map((item) => item.UserId).join(",");
    const mappedValue = arr.map((item) => item.UserId);
    console.log(mappedValue, "mappedValue654321");
    console.log("ids", idsString, arr);
    getCustomerFilterList(idsString, 0);
    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: {
        ...localFilter,
        customer: mappedValue,
        page: 0
      },
    });
    setFilter(localFilter);
    setPage(0); 
    console.log("select custrrr", customerListSelectFilter);
  };
  const handlePageChange = (e, value) => {
    console.log(value,'valuessssssss', value -1)
    setPage(value - 1);
    dispatch({
      type: PAGE_OFFSET,
      payload: value - 1,
    });
    getCustomerFilterList("", value -1);
    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: {
        ...filter,
        page: value - 1
      },
    });
  };

  const clearProject = () => {
    setPage(0);
    setPersonName([]);
    setFilter(filterInitial);
    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: {
        ...filter,
        page: 0
      },
    });
    getCustomerList();
  };

  useEffect(() => {
    if (backButtonFilter) {
      if (selectedCustomers && selectedCustomers.length > 0) {
        let userIds = selectedCustomers.map((user) => user.UserId);
        getCustomerFilterList(userIds.join(","), "");
      } else {
        getCustomerFilterList("", "");
      }
      setBackButtonFilter(false);
    }
  }, [backButtonFilter]);

  useEffect(() => {
    const { state } = location;

    if (state && state.type === "backbutton") {
      const CUSTOMER_PAGE_FILTER = localStorage.getItem("CUSTOMER_PAGE_FILTER");
      const CUSTOMER_PAGE_SEARCH = localStorage.getItem("CUSTOMER_PAGE_SEARCH");
      console.log(
        deCryptFun(CUSTOMER_PAGE_FILTER),
        "deCryptFun(CUSTOMER_PAGE_FILTER)deCryptFun(CUSTOMER_PAGE_FILTER)"
      );
      var CUSTOMER_PAGE_FILTER_DEC = "";
      var CUSTOMER_PAGE_SEARCH_DEC = "";

      if (CUSTOMER_PAGE_FILTER) {
        CUSTOMER_PAGE_FILTER_DEC = deCryptFun(CUSTOMER_PAGE_FILTER);
        CUSTOMER_PAGE_FILTER_DEC = CUSTOMER_PAGE_FILTER
          ? JSON.parse(CUSTOMER_PAGE_FILTER_DEC)
          : "";
      }
      if (CUSTOMER_PAGE_SEARCH) {
        CUSTOMER_PAGE_SEARCH_DEC = deCryptFun(CUSTOMER_PAGE_SEARCH);
        CUSTOMER_PAGE_SEARCH_DEC = CUSTOMER_PAGE_SEARCH
          ? JSON.parse(CUSTOMER_PAGE_SEARCH_DEC)
          : "";
      }

      if (CUSTOMER_PAGE_SEARCH_DEC && CUSTOMER_PAGE_SEARCH_DEC.length > 0) {
        setSelectedCustomers(CUSTOMER_PAGE_SEARCH_DEC);
      }

      if (CUSTOMER_PAGE_FILTER_DEC) {
        setFilter(CUSTOMER_PAGE_FILTER_DEC);
        // dispatch({
        //   type: types.CUSTOMER_SELECT_LIST_FILTER,
        //   payload: {
        //     CUSTOMER_PAGE_FILTER_DEC
        //   },
        // });
        setApplyFilterFlag(true);
      }

      setBackButtonFilter(true);
    } else {
      // getCustomerList();
    }
    dispatch(getAllCustomersList());
  }, []);

  const localStorageFilter = (value) => {
    if (value) {
      localStorage.setItem(
        "CUSTOMER_PAGE_FILTER",
        enCryptFun(JSON.stringify(filter))
      );
      localStorage.setItem(
        "CUSTOMER_PAGE_SEARCH",
        enCryptFun(JSON.stringify(selectedCustomers))
      );
    } else {
      localStorage.removeItem("CUSTOMER_PAGE_FILTER", "");
      localStorage.removeItem("CUSTOMER_PAGE_SEARCH", "");
    }
    localStorage.removeItem("DASHBOARD_NAVI");
  };
  useEffect(() => {
    if (isInitialLoad) {
      dispatch({
        type: PAGE_OFFSET,
        payload: 0,
      });
      setIsInitialLoad(false);
    }
  }, [isInitialLoad, dispatch]);
  useEffect(() => {
    if (currentPage) {
      setPage(currentPage);
    }
  }, [currentPage]);

  useEffect(() => {

    if (sortClickedTime) {
    getCustomerFilterList();   
    }
  }, [sortClickedTime]);
  return (
    <>
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide= {'1'}/>

        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar title="Customer Management" />

          <Box className="bg-box user-log">
            <Grid container>
              <Grid xs={5} sm={12} md={5}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  options={customerList}
                  disableCloseOnSelect
                  limitTags={1}
                  popupIcon={<KeyboardArrowDownIcon />}
                  getOptionLabel={(option) => option.Name}
                  filterOptions={(options, { inputValue }) => {
                    if (inputValue.trim() === "") {
                      return options;
                    }
                    return options.filter((option) =>
                      option.Name.toLowerCase().includes(
                        inputValue.toLowerCase()
                      )
                    );
                  }}
                  onChange={handleSearchOnChange}
                  value={selectedCustomers}
                  renderTags={() => null}
                  renderOption={(props, option, { selected }) => {
                    const isSelected = selectedCustomers.some(
                      (project) => project.UserId === option.UserId
                    );

                    return (
                      <li {...props} key={option.UserId}>
                        <Checkbox
                          className="search-checkbox"
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={isSelected}
                          onChange={() =>
                            handleSearchCheckboxOnChange(option, isSelected)
                          }
                        />
                        <span className="select-option-text">
                          {option.Name}
                        </span>
                      </li>
                    );
                  }}
                  sx={{
                    width: { xs: "100%", md: 300 },
                    minWidth: { xs: "230px", md: "auto" },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Search Customers"
                    />
                  )}
                />
                <div>
                  {selectedCustomers.map((option) => (
                    <Chip
                      key={option.UserId}
                      label={option.Name}
                      onDelete={() => {
                        handleSearchDeleteOnChange(option.UserId);
                      }}
                      style={{ margin: 5 }}
                    />
                  ))}
                </div>

                {/* <FormControl className="search-box" sx={{ m: 1, width: 265 }}>
                  <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    value={personName}
                    onChange={handleChangeCustomer}
                    input={<OutlinedInput id="select-multiple-chip" />}
                    renderValue={(selected) => (
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {selected.map((customerId) => {
                          const customer = customerList.find(
                            (c) => c.UserId === customerId
                          );
                          return (
                            <Chip
                              key={customerId}
                              label={customer ? customer.Name : "Unknown"}
                            />
                          );
                        })}
                      </div>
                    )}
                    MenuProps={MenuProps}
                    startAdornment={
                      <InputAdornment position="start">
                        <span class="material-symbols-outlined">search</span>
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="start">
                        {personName && personName.length > 0 ? (
                          <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={clearProject}
                          >
                            <HighlightOffIcon fontSize="small" />
                          </IconButton>
                        ) : (
                          ""
                        )}
                      </InputAdornment>
                    }
                  >
                    {customerList.map((value) => (
                      <MenuItem key={value.UserId} value={value.UserId}>
                        <Checkbox
                          checked={personName.indexOf(value.UserId) > -1}
                        />
                        <ListItemText primary={value.Name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}
              </Grid>
              <Grid sx={{ mt: "auto", mb: "auto" }} xs={12} sm={12} md={7}>
                <Stack
                  sx={{
                    float: { xs: "left", md: "right" },
                    alignItems: { xs: "flex-start", md: "center" },
                    marginTop: {
                      xs: "10px !important",
                      md: "0px !important",
                    },
                  }}
                  direction={{ xs: "column", sm: "row" }}
                  spacing={1.3}
                >
                  {selectedCustomers?.length > 0 ||
                  (customerListSelectFilter &&
                    // applyFilterFlag == true &&
                    (customerListSelectFilter.customer?.length > 0 ||
                      customerListSelectFilter.customerStatus !== "" ||
                      customerListSelectFilter.customerStatusActive !== "" ||
                      customerListSelectFilter.billingDefaultperiod !== "" ||
                      customerListSelectFilter.billingDefaultDayRate !==
                        "")) ? (
                    <Button
                      sx={{
                        marginTop: {
                          xs: "10px !important",
                          md: "0px !important",
                        },
                      }}
                      startIcon={
                        <span class="material-symbols-outlined">close</span>
                      }
                      className="clear-btn"
                      variant="contained"
                      onClick={clearFilterOpen}
                    >
                      Clear Filter
                    </Button>
                  ) : (
                    ""
                  )}

                  <Stack
                    className="filter"
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    onClick={filterOpenFun}
                  >
                    <span class="material-symbols-outlined">filter_list</span>
                    <Typography>Filter</Typography>
                  </Stack>
                  <Link
                    to={{
                      pathname: CUSTOMER_HISTORY,
                    }}
                  >
                    <Button
                      sx={{ width: "max-content" }}
                      startIcon={
                        <span class="material-symbols-outlined">person</span>
                      }
                      className="secondary-btn"
                      variant="contained"
                    >
                      Customer History
                    </Button>
                  </Link>
                  <Link
                    to={{
                      pathname: ADD_CUSTOMER,
                    }}
                  >
                    <Button
                      sx={{ width: "max-content" }}
                      startIcon={
                        <span class="material-symbols-outlined">add</span>
                      }
                      className="primary-btn"
                      variant="contained"
                      color="success"
                    >
                      New Customer
                    </Button>
                  </Link>
                </Stack>
              </Grid>
            </Grid>

            <Grid sx={{ mt: 2 }} container>
              <Grid xs={12} md={12}>
                <TableContainer
                  sx={{ boxShadow: "none", maxHeight: 440 }}
                  component={Paper}
                >
                  <Table
                    sx={{ minWidth: 650 }}
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{ minWidth: { xs: "1150px", md: "300px" } }}
                        >
                          <TableSortLabel
                            active={orderBy === "Name"}
                            direction={orderBy === "Name" ? order : "asc"}
                            onClick={() => handleSortRequest("Name")}
                            IconComponent={() => getSortIcon("Name")}
                            style={
                              filter.orderBy === "Name" ? { color: "#007fff" } : {}
                            }
                          >
                            Customer
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          sx={{ minWidth: { xs: "auto", md: "100px" } }}
                        >
                          <TableSortLabel
                            active={orderBy === "DefaultDayRate"}
                            direction={
                              orderBy === "DefaultDayRate" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("DefaultDayRate")}
                            IconComponent={() => getSortIcon("DefaultDayRate")}
                            style={
                              filter.orderBy === "DefaultDayRate"
                                ? { color: "#007fff" }
                                : {}
                            }
                          >
                            Billing Default Day Rate
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            sx={{ minWidth: { xs: "150px", md: "100px" } }}
                            active={orderBy === "BillingPeriod"}
                            direction={
                              orderBy === "BillingPeriod" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("BillingPeriod")}
                            IconComponent={() => getSortIcon("BillingPeriod")}
                            style={
                              filter.orderBy === "BillingPeriod"
                                ? { color: "#007fff" }
                                : {}
                            }
                          >
                            Billing Default Period (in days)
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            sx={{ minWidth: "159px" }}
                            active={orderBy === "CreatedDate"}
                            direction={
                              orderBy === "CreatedDate" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("CreatedDate")}
                            IconComponent={() => getSortIcon("CreatedDate")}
                            style={
                              filter.orderBy === "CreatedDate"
                                ? { color: "#007fff" }
                                : {}
                            }
                          >
                            Created Date
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ minWidth: "117px" }}>
                          <TableSortLabel
                            active={orderBy === "Active"}
                            direction={orderBy === "Active" ? order : "asc"}
                            onClick={() => handleSortRequest("Active")}
                            IconComponent={() => getSortIcon("Active")}
                            style={
                              filter.orderBy === "Active" ? { color: "#007fff" } : {}
                            }
                          >
                            Status
                          </TableSortLabel>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {loading && <CustomPageLoading />}
                    <TableBody>
                      {list &&
                        list.map((r) => {
                          const {
                            UserId,
                            Name,
                            BillingPeriod,
                            DefaultDayRate,
                            CreatedDate,
                            Active,
                          } = r;
                          var dataMoment = CreatedDate
                            ? moment(CreatedDate).format("MMMM Do YYYY, h:mm A")
                            : "";
                          return (
                            <TableRow
                              component={Link}
                              to={{
                                pathname: `/customer-details/${UserId}`,
                                state: { id: UserId },
                              }}
                              key={UserId}
                              onClick={() => localStorageFilter(true)}
                            >
                              <TableCell
                                style={{ lineBreak: "anywhere" }}
                                scope="row"
                              >
                                {Name}
                              </TableCell>
                              <TableCell>
                                {DefaultDayRate ? "$" + DefaultDayRate?.toFixed(2) : "$0.00"}
                              </TableCell>
                              <TableCell>
                                {" "}
                                {BillingPeriod ? BillingPeriod : 0} Days{" "}
                              </TableCell>
                              <TableCell
                                sx={{ minWidth: { xs: "auto", md: "226px" } }}
                              >
                                {dataMoment || '-'}
                              </TableCell>
                              <TableCell sx={{ minWidth: "125px" }}>
                                <span
                                  className={
                                    Active == 1 ? "active-btn" : "inactive-btn"
                                  }
                                >
                                  {Active == 1 ? "Active" : "Inactive"}
                                </span>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>

                    {/* <TableBody>
                      <TableRow>
                        <TableCell scope="row">May 3 2024 9:40A</TableCell>
                        <TableCell>gabrielv+admin@apptomate.co</TableCell>
                        <TableCell>
                          Billing statement (12/15/2017 - 12/31/2017) was
                          reopened in project 'Test Project' for customer 'Ryan
                          Test Customer1'.
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell scope="row">May 3 2024 9:40A</TableCell>
                        <TableCell>gabrielv+admin@apptomate.co</TableCell>
                        <TableCell>
                          Billing statement (12/15/2017 - 12/31/2017) was
                          reopened in project 'Test Project' for customer 'Ryan
                          Test Customer1'.
                        </TableCell>
                      </TableRow>
                    </TableBody> */}
                  </Table>
                  <br />
                </TableContainer>
                {!loading && list && list.length == 0 ? (
                  <NoRecordFound />
                ) : (
                  <></>
                )}
                {!loading && total > 0 && (
                  <Pagination
                    sx={{ mt: "15px", float: "right" }}
                    shape="rounded"
                    // hidePrevButton
                    // hideNextButton
                    renderItem={(item) => (
                      <PaginationItem
                        components={{
                          previous: () => (
                            <Icon className="material-symbols-outlined">
                              keyboard_backspace
                            </Icon>
                          ),
                          next: () => (
                            <Icon className="material-symbols-outlined">
                              east
                            </Icon>
                          ),
                        }}
                        {...item}
                      />
                    )}
                    count={total}
                    page={customerListSelectFilter?.page + 1}
                    onChange={handlePageChange}
                  />
                )}

                {openFilter && (
                  <CustomerFilterModel
                    open={openFilter}
                    handleClose={filterClose}
                    filterValue={filter}
                    setFilterValue={setFilter}
                    filterInitial={filterInitial}
                    applyFilterFun={applyFilterFun}
                    customerNameList={customerList}
                    selectedCustomers={selectedCustomers}
                    setSelectedCustomers={setSelectedCustomers}
                  />
                )}
                {clearFlag && (
                  <UserClearFilter
                    open={clearFlag}
                    clearFiltervalue={clearFiltervalue}
                    setClearFilterValue={setClearFilterValue}
                    resetFilter={resetFilter}
                  />
                )}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Customer;
